/**
 * Тур по странице сповіщень (Notifications).
 * Знайомить користувача з налаштуванням каналів та правил сповіщень.
 * ВАЖНО: Тур працює тільки на великих екранах (>= 769px).
 */
export default {
  id: 'notifications-page',
  name: 'help.tours.notifications.name',
  description: 'help.tours.notifications.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Крок 1: Привітання
    {
      element: '.page-title',
      titleKey: 'help.tours.notifications.welcome.title',
      descriptionKey: 'help.tours.notifications.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Крок 2: Вкладки (Канали / Правила)
    {
      element: '.ntf-tabs',
      titleKey: 'help.tours.notifications.tabs.title',
      descriptionKey: 'help.tours.notifications.tabs.description',
      side: 'bottom',
      align: 'start',
    },
    // Крок 3: Картка налаштувань
    {
      element: '.ntf-card',
      titleKey: 'help.tours.notifications.card.title',
      descriptionKey: 'help.tours.notifications.card.description',
      side: 'bottom',
      align: 'center',
    },
    // Крок 4: Таблиця налаштувань (матриця)
    {
      element: '.prefs-table-wrapper',
      titleKey: 'help.tours.notifications.preferences.title',
      descriptionKey: 'help.tours.notifications.preferences.description',
      side: 'top',
      align: 'center',
    },
  ],
}
